/**
 * apCatalog  (DA-2184)
 *
 * Shared option builders for the AP side of the mapper builder, so every appliance
 * dropdown in the feature labels its entries identically.
 */
import { ApplianceCatalog } from 'types/apis/surveyInterfaces'

/**
 * Appliance ids are what the grammar actually encodes (`AP:20-C`, `AP:20&19:C:0-1`), and
 * names alone don't disambiguate them — the catalog ships several near-identical ones
 * across categories ("Room AC" / "Central AC", four sprinkler variants). Showing the id
 * alongside the name lets the admin match what they pick against the resolved string.
 */
export function applianceOptions(appliances?: ApplianceCatalog[]): { value: string; label: string }[] {
  return (appliances ?? []).map((a) => ({
    value: String(a.applianceId),
    label: `${a.name} (${a.applianceId})`,
  }))
}
